import {Case} from './Case';
import {Address} from './Address';

export class CaseAddresses {
    buildingname: string
    buildingnumber: string
    buildingIdentifier: string
    coordssource: number | string
    country: string
    county: string
    dependantthoroughfarename: string
    caseaddressid: number;
    casefileid: number;
    locality: string
    organisation: string
    paon: string
    postcode: string
    saon: string
    street: string
    subbuildingname: string
    thoroughfaredescriptor: string
    thoroughfare: string
    towncity: string
    town: string
    AddressDbSourced: boolean;
    uprn: string
    northing: number;
    easting: number;
    dependentthoroughfarename: string
    case: Case;
    propertytype?: string;

    constructor(_buildingname: string, _buildingnumber: string,
                _country: string, _county: string
        , _caseaddressid: number, _casefileid: number, _locality: string,
                _organisation: string, _postcode: string, _thoroughfare: string, _dependantthoroughfarename: string, _street: string, _subbuildingname: string,
                _towncity: string, _uprn: string, _northing: number, _easting: number
    ) {
        this.buildingname = _buildingname;
        this.buildingnumber = _buildingnumber;
        this.country = _country;
        this.county = _county;
        this.caseaddressid = _caseaddressid;
        this.casefileid = _casefileid;
        this.locality = _locality;
        this.organisation = _organisation;
        this.postcode = _postcode;
        this.thoroughfare = _thoroughfare;
        this.dependantthoroughfarename = _dependantthoroughfarename;
        this.street = _street;
        this.subbuildingname = _subbuildingname;
        this.towncity = _towncity;
        this.uprn = _uprn;
        this.northing = _northing;
        this.easting = _easting;
    }

    asAddress(setNullsToEmpty: boolean): Address {
        var addr = new Address(this.buildingIdentifier, this.buildingnumber, this.buildingname, this.thoroughfare, this.dependantthoroughfarename,  this.postcode, [], [], this.uprn);
        addr.locality = this.locality;
        addr.organisation = this.organisation;
        addr.town = this.town != null ? this.town : this.towncity;
        addr.county = this.county;
        addr.subbuildingname = this.subbuildingname;
        addr.street = this.street;

        if (setNullsToEmpty) {
            addr.buildingIdentifier = this.getSanitized(addr.buildingIdentifier);
            addr.buildingnumber = this.getSanitized(addr.buildingnumber);
            addr.buildingname = this.getSanitized(addr.buildingname);
            addr.thoroughfare = this.getSanitized(addr.thoroughfare != null ? addr.thoroughfare : addr.street);
            addr.postcode = this.getSanitized(addr.postcode);
            addr.uprn = this.getSanitized(addr.uprn);
            addr.locality = this.getSanitized(addr.locality);
            addr.organisation = this.getSanitized(addr.organisation);
            addr.town = this.getSanitized(addr.town);
            addr.county = this.getSanitized(addr.county);
            addr.subbuildingname = this.getSanitized(addr.subbuildingname);
            addr.street = this.getSanitized(addr.street);
        }

        return addr;
    }

    getSanitized(value: string) {
        if (value == null) {
            return "";
        }
        return value;
    }
}
